import { Controller } from '@hotwired/stimulus'

// Keeps the hidden `current_tab` field in sync with the active tab so that,
// when the form is submitted, the server can redirect back to the same tab.
// Without this, the hidden field would retain its initial value even if the
// user switched tabs client-side before saving.
export default class extends Controller {
  static targets = ['currentTabInput']

  rememberTab(event) {
    const tabsTarget = event.target.dataset.tabsTarget
    if (tabsTarget) this.currentTabInputTarget.value = tabsTarget.replace(/^#/, '')
  }
}
